/**
 * When the reader wants the explorer / copy / catalog icons beside an address
 * or hash drawn, everywhere: always, on hover, or as each page decides.
 *
 * Lives with the overlays feature, beside `useChipPrefs`, because the root
 * address provider is what spends it — the Settings card only edits it.
 * `undefined` means the reader has not chosen (or chose "each page decides").
 */
import { useDisplayPref } from "@authe/ui-core";
import type { QuickActionVisibility } from "@authe/fe-commons/display";
import { displayPrefs } from "@/app/prefs";

export function useQuickActionsPref(): [
  QuickActionVisibility | undefined,
  (value: QuickActionVisibility | undefined) => void,
] {
  return useDisplayPref<QuickActionVisibility | undefined>(
    () => displayPrefs.getQuickActions(),
    (value) => displayPrefs.setQuickActions(value),
  );
}
